import { makeStyles } from '@material-ui/core';
import Theme from '../../theme/booking-theme';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    padding: '25px 20px',
    position: 'relative',
    maxWidth: 1440,
    margin: '0 auto',
    [Theme.breakpoints.up('sm')]: {
      padding: '25px 50px',
    },
    [Theme.breakpoints.up('xl')]: {
      padding: '25px 36px',
    },

    '& .footer-copyright': {
      width: '60%',
    },
    '& .link-container': {
      width: '40%',
      textAlign: 'right',
      '& a': {
        color: Theme.palette.blue2,
        padding: '0 0 0 20px',
        '&:hover': {
          backgroundColor: 'transparent',
          cursor: 'pointer',
          textDecoration: 'none',
        },
        [Theme.breakpoints.only('xs')]: {
          padding: '0 0 0 10px',
        },
      },
    },
    '& .MuiTypography-body1': {
      fontSize: '0.7rem',
    },
  },
});

export default useStyles;
